import { PAY_PER_INTERACTION_GUIDE } from './payPerInteraction.js';
import { MICRO_INFLUENCER_MARKETING_GUIDE } from './microInfluencerMarketing.js';
import { CPE_BENCHMARKS_GUIDE } from './cpeBenchmarks2026.js';
import { INFLUENCER_MARKETING_ROI_GUIDE } from './influencerMarketingROI.js';
import { FIND_INFLUENCERS_GUIDE } from './findInfluencers2026.js';
import { INSTAGRAM_INFLUENCER_RATES_GUIDE } from './instagramInfluencerRates2026.js';
import { TIKTOK_CREATOR_MARKETING_GUIDE } from './tiktokCreatorMarketing2026.js';
import { INFLUENCER_CAMPAIGN_BRIEF_GUIDE } from './influencerCampaignBrief.js';

// Source of truth for the public guide catalogue. Ordered roughly by
// authority — hub first, then cornerstones, then spokes.
export const ALL_GUIDES = [
    PAY_PER_INTERACTION_GUIDE,
    MICRO_INFLUENCER_MARKETING_GUIDE,
    CPE_BENCHMARKS_GUIDE,
    INFLUENCER_MARKETING_ROI_GUIDE,
    FIND_INFLUENCERS_GUIDE,
    INSTAGRAM_INFLUENCER_RATES_GUIDE,
    TIKTOK_CREATOR_MARKETING_GUIDE,
    INFLUENCER_CAMPAIGN_BRIEF_GUIDE,
];

export function getRelatedGuides(currentSlug, limit = 3) {
    const pool = ALL_GUIDES.filter((g) => g.slug !== currentSlug);
    if (pool.length <= limit) return pool;
    // Pick guides spread evenly across the catalogue so old and new guides
    // always cross-link regardless of insertion order.
    const stride = pool.length / limit;
    return Array.from({ length: limit }, (_, i) => pool[Math.round(i * stride)]);
}
